module.exports = __webpack_public_path__ + "static/img/head_img.b2cd78d0.png";